import type { StickerColor } from '@/modules/common/types/sticker-color.type.ts';
import type { ItemsDto } from '@/modules/common/dto/items.dto.ts';
import type { DocumentStatusDto } from '@/modules/document/dto/document-status.dto.ts';
import { DocumentStatusId } from '@/modules/common/enums/document-status-id.enum.ts';
import type { DocumentStatus } from '@/modules/document/types/document-status.type.ts';

interface DocumentStatusInfo {
  title: string;
  color: StickerColor;
}

export class DocumentStatusAdapter {
  private static readonly MAP: Record<DocumentStatusId, DocumentStatusInfo> = {
    [DocumentStatusId.Draft]: {
      title: 'document.status.draft',
      color: 'gray',
    },
    [DocumentStatusId.Paused]: {
      title: 'document.status.paused',
      color: 'dark-gray',
    },
    [DocumentStatusId.Running]: {
      title: 'document.status.running',
      color: 'green',
    },
    [DocumentStatusId.Expired]: {
      title: 'document.status.expired',
      color: 'red',
    },
    [DocumentStatusId.Stopped]: {
      title: 'document.status.stopped',
      color: 'translucent',
    },
    [DocumentStatusId.Standard]: {
      title: 'document.status.standard',
      color: 'blue',
    },
  };

  static map(id: DocumentStatusId): DocumentStatus {
    return {
      id,
      name: DocumentStatusAdapter.MAP[id].title,
      color: DocumentStatusAdapter.MAP[id].color,
    };
  }

  static mapList(response: ItemsDto<DocumentStatusDto>) {
    return response.items.map((item) => DocumentStatusAdapter.map(item.DS_ID));
  }
}
